module.exports = __webpack_public_path__ + "img/10.bb6f6c69.svg";